'use client'

import { statsAgencyDetail } from '@plugin/statistics'
import { useMount } from 'react-use'

export default function Stats({
  data
}) {

  useMount(() => {
    statsAgencyDetail(data.id)
  })
}